// extracted by mini-css-extract-plugin
module.exports = {"leftPanel":"Header_leftPanel__13xRP","rightPanel":"Header_rightPanel__eRhMr","headerTitle":"Header_headerTitle__1oUVY"};